import React from 'react';
import {
  FacebookIcon,
  TwitterIcon,
  InstagramIcon,
  YoutubeIcon,
  TikTokIcon,
  NewsIcon,
  Linkedin,
  SnapChatIcon,
  TelegramIcon,
  TwitterUnActiveIcon,
  LinkedinPlatformIcon,
  SuspendInsta,
  SuspendTwitterIcon,
  SuspendTiktokIcon,
  SuspendYoutube,
  SuspendInstagram,
  SuspendFacebook,
} from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
const imagesMap: any = (isSuspended: boolean) => ({
  [_t('basic:youtube')]: isSuspended ? <SuspendYoutube /> : <YoutubeIcon />,
  [_t('basic:twitter')]: isSuspended ? <SuspendTwitterIcon /> : <TwitterIcon />,
  [_t('basic:instagram')]: isSuspended ? (
    <SuspendInstagram />
  ) : (
    <InstagramIcon />
  ),
  [_t('basic:facebook')]: isSuspended ? <SuspendFacebook /> : <FacebookIcon />,
  [_t('basic:tiktok')]: isSuspended ? <SuspendTiktokIcon /> : <TikTokIcon />,

  [_t('basic:source')]: <NewsIcon />,
  [_t('basic:linkedin')]: <LinkedinPlatformIcon />,
  [_t('basic:telegram')]: <TelegramIcon />,
  [_t('basic:snapchat')]: <SnapChatIcon />,
});
export const renderPlatformIcon = (
  platform: string,
  withTrans?: boolean,
  status?: 'ACTIVE' | 'SUSPENDED' | 'PRIVATE' | 'DEACTIVATED',
): JSX.Element => {
  platform = platform?.toLowerCase();
  if (withTrans) platform = _t(`basic:${platform}`);

  const isSuspended =
    status === 'SUSPENDED' || status === 'PRIVATE' || status === 'DEACTIVATED';
  return imagesMap(isSuspended)[platform];
};

export const renderPlatforms = (key: string): JSX.Element => {
  const icons: any = {
    youtube: <YoutubeIcon />,
    twitter: <TwitterIcon />,
    instagram: <InstagramIcon />,
    facebook: <FacebookIcon />,
    tiktok: <TikTokIcon />,
    linkedin: <Linkedin />,
    telegram: <TelegramIcon />,
    snapchat: <SnapChatIcon />,
  };
  if (key in icons) return icons[key];
  return <></>;
};
